<template>
	<Dialog
		:dialogVisible.sync="dialog"
		:title="title"
		:message="message"
		:agreeText="agreeText"
		:cancelText="cancelText"
		:isAngry="isAngry"
		:removeCancelButton="removeCancelButton"
		:options="options"
		@cancel="cancel"
		@agree="agree">
	</Dialog>
</template>

<script>
	export default {
		data: () => ({
			dialog: false,
			resolve: null,
			reject: null,
			message: null,
			requireDeleteConfirmation: false,
			deleteConfirmationText: null,
			title: null,
			agreeText: "Yes",
			cancelText: "No",
			isAngry: false,
			removeCancelButton: false,
			options: {
				width: "500px",
			},
		}),
		methods: {
			open(
				title,
				message,
				requireDeleteConfirmation,
				agreeText,
				cancelText,
				isAngry,
				removeCancelButton,
				options = {
					width: "500px",
				}
			) {
				this.dialog = true;
				this.title = title || "Are you sure?";
				this.agreeText = agreeText || "Yes";
				this.cancelText = cancelText || "No";
				this.message = message || "You can't undo this. Are you sure you want to continue?";
				this.isAngry = isAngry || false;
				this.requireDeleteConfirmation = requireDeleteConfirmation;
				this.removeCancelButton = removeCancelButton || false;
				this.options = options;
				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
			},
			deleteOpen(title, message) {
				return this.open(title, message, false, "Delete", "Cancel", true);
			},
			agree() {
				this.resolve(true);
				this.dialog = false;
			},
			cancel() {
				this.dialog = false;
				this.resolve(false);
			},
		},
	};
</script>
